export default __webpack_public_path__ + "static/media/coverone.380ba422.txt";